export const DEFAULT_CONFIG = {
    apiUrl: 'https://simulation.a.exodus.io',
};
